<div class="container-global">
  <h2 class="primary-color">MON ESPACE</h2>
  <h3>Mes factures</h3>
  <div class="container-fil-ariane">
    <ags-fil-ariane [name]="'Mon espace'" [link]="'/account'"></ags-fil-ariane>
    <p class="space-fil-ariane">></p>
    <ags-fil-ariane [name]="'Mes factures'" [link]="'/mesfactures'"></ags-fil-ariane>
  </div>
  <lib-ags-kendo-grid-list
    [titlefield]="'Liste des factures'"
    [gridConfig]="gridSettings"
    [downloadFunction]="documentService.getDocumentPresigned"
    [table]="'facture'"
    [data]="factureList"
  >
  </lib-ags-kendo-grid-list>
</div>
